import { useState } from "react";
import { ListChecks } from "lucide-react";

export const LessonQuiz = ({ quiz }) => {
  const [picks, setPicks] = useState({});
  if (!quiz?.length) return null;
  const score = quiz.filter((q, i) => picks[i] === q.answer_index).length;
  return (
    <div className="mt-6 rounded-xl bg-white/[0.03] border border-white/10 p-5" data-testid="lesson-quiz">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-amber-300 font-semibold text-sm"><ListChecks className="h-4 w-4" /> Check your understanding</div>
        {Object.keys(picks).length === quiz.length && <span className="text-xs text-emerald-400" data-testid="quiz-score">{score}/{quiz.length} correct</span>}
      </div>
      <div className="space-y-5">
        {quiz.map((q, i) => (
          <div key={q.question}>
            <p className="text-sm text-white mb-2">{i + 1}. {q.question}</p>
            <div className="grid sm:grid-cols-2 gap-2">
              {q.options.map((o, j) => {
                const chosen = picks[i] === j;
                const done = picks[i] !== undefined;
                const tone = done && j === q.answer_index ? "border-emerald-500/60 bg-emerald-500/10 text-emerald-200"
                  : chosen ? "border-red-500/60 bg-red-500/10 text-red-200" : "border-white/10 text-slate-300 hover:border-amber-500/50";
                return (
                  <button key={o} type="button" disabled={done} data-testid={`quiz-${i}-opt-${j}`} onClick={() => setPicks({ ...picks, [i]: j })}
                    className={`text-left text-xs rounded-lg border px-3 py-2 transition-colors ${tone}`}>{o}</button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
